import router from '@/router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {getToken} from "./admin"
import store from "../store/index"

NProgress.configure({showSpinner: false});

const whiteList = ['/login'];

router.beforeEach(async (to, from, next) => {
    NProgress.start();
    if (store.state.app.redMsg) {
        document.title = `互联天下代理商-${to.name}`;
    }
    const hasToken = getToken();
    if (hasToken) {
        if (to.path === '/login') {
            next({path: '/'});
            NProgress.done()
        } else {
            next()
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next(`/login?redirect=${to.path}`);
            NProgress.done()
        }
    }
});

router.afterEach(() => {
    NProgress.done()
});
